export enum Permissions {
  PROMPT_CREATE = "prompt_create",
  PROMPT_EDIT = "prompt_edit",
  PROMPT_DELETE = "prompt_delete",
  PROMPT_DEPLOY = "prompt_deploy",
  WORKFLOW_CREATE = "workflow_create",
  WORKFLOW_EDIT = "workflow_edit",
  WORKFLOW_DELETE = "workflow_delete",
  WORKFLOW_DEPLOY = "workflow_deploy",
  DATASET_CREATE = "dataset_create",
  DATASET_EDIT = "dataset_edit",
  DATASET_DELETE = "dataset_delete",
  REPORT_CREATE = "report_create",
  REPORT_EDIT = "report_edit",
  REPORT_DELETE = "report_delete",
  TOOL_CREATE = "tool_create",
  TOOL_EDIT = "tool_edit",
  TOOL_DELETE = "tool_delete",
  TOOL_DEPLOY = "tool_deploy",
  MANAGE_API_KEYS = "manage_api_keys",
  METADATA_EDIT = "metadata_edit",
  ADMIN = "admin",
}

export enum PermissionResource {
  PROMPTS = "prompts",
  WORKFLOWS = "workflows",
  DATASETS = "datasets",
  EVALUATIONS = "evaluations",
  TOOLS = "tools",
  WORKSPACE = "workspace",
}

export const PERMISSION_LABELS: Record<
  Permissions,
  { action: string; entity: string; resource: PermissionResource; label?: string }
> = {
  prompt_create: {
    action: "create",
    entity: "prompts",
    resource: PermissionResource.PROMPTS,
    label: "Create prompts",
  },
  prompt_edit: {
    action: "update",
    entity: "prompts",
    resource: PermissionResource.PROMPTS,
    label: "Update prompts",
  },
  prompt_delete: {
    action: "delete",
    entity: "prompts",
    resource: PermissionResource.PROMPTS,
    label: "Delete prompts",
  },
  prompt_deploy: {
    action: "manage release labels",
    entity: "prompt",
    resource: PermissionResource.PROMPTS,
    label: "Manage release labels",
  },
  workflow_create: {
    action: "create",
    entity: "workflows",
    resource: PermissionResource.WORKFLOWS,
    label: "Create workflows",
  },
  workflow_edit: {
    action: "update",
    entity: "workflows",
    resource: PermissionResource.WORKFLOWS,
    label: "Update workflows",
  },
  workflow_delete: {
    action: "delete",
    entity: "workflows",
    resource: PermissionResource.WORKFLOWS,
    label: "Delete workflows",
  },
  workflow_deploy: {
    action: "manage release labels",
    entity: "workflow",
    resource: PermissionResource.WORKFLOWS,
    label: "Manage release labels",
  },
  dataset_create: {
    action: "create",
    entity: "datasets",
    resource: PermissionResource.DATASETS,
    label: "Create datasets",
  },
  dataset_edit: {
    action: "update",
    entity: "datasets",
    resource: PermissionResource.DATASETS,
    label: "Update datasets",
  },
  dataset_delete: {
    action: "delete",
    entity: "datasets",
    resource: PermissionResource.DATASETS,
    label: "Delete datasets",
  },
  report_create: {
    action: "create",
    entity: "evaluations",
    resource: PermissionResource.EVALUATIONS,
    label: "Create evaluations",
  },
  report_edit: {
    action: "update",
    entity: "evaluations",
    resource: PermissionResource.EVALUATIONS,
    label: "Update evaluations",
  },
  report_delete: {
    action: "delete",
    entity: "evaluations",
    resource: PermissionResource.EVALUATIONS,
    label: "Delete evaluations",
  },
  tool_create: {
    action: "create",
    entity: "tools",
    resource: PermissionResource.TOOLS,
    label: "Create tools",
  },
  tool_edit: {
    action: "update",
    entity: "tools",
    resource: PermissionResource.TOOLS,
    label: "Update tools",
  },
  tool_delete: {
    action: "delete",
    entity: "tools",
    resource: PermissionResource.TOOLS,
    label: "Delete tools",
  },
  tool_deploy: {
    action: "deploy",
    entity: "tools",
    resource: PermissionResource.TOOLS,
    label: "Deploy tool labels",
  },
  manage_api_keys: {
    action: "manage API keys",
    entity: "API keys",
    resource: PermissionResource.WORKSPACE,
    label: "Manage API keys",
  },
  metadata_edit: {
    action: "update",
    entity: "metadata",
    resource: PermissionResource.PROMPTS,
    label: "Update metadata",
  },
  admin: {
    action: "manage workspace",
    entity: "workspace",
    resource: PermissionResource.WORKSPACE,
    label: "Manage workspace",
  },
};
